/**
 * massActionsListingHelpers — pure helpers for mass-action toolbar state.
 *
 * A14 from listing-abstraction-opportunities.md
 *
 * Two small helpers:
 *   1. createNarrowingParams — wraps a serialized narrowing query string in a
 *      fresh URLSearchParams so modal mutations never accumulate on a shared
 *      instance (IP-14655).
 *   2. toMassActionsListingState — builds the rows-with-selected-flags view
 *      model that the MassActions toolbar expects.
 */
// ---------------------------------------------------------------------------
// A14a — createNarrowingParams
// ---------------------------------------------------------------------------
/**
 * Returns a fresh URLSearchParams wrapping the given serialized query string.
 * Callers should call this once per consumer (not share an instance) so that
 * modal mutations (e.g. .append()) never accumulate across renders.
 */
export function createNarrowingParams(serialized) {
    return new URLSearchParams(serialized);
}
const RESERVED_MASS_ACTION_KEYS = new Set(['data', 'selectAll', 'totalCount']);
/**
 * Builds a mass-actions view model from selection state.
 * Maps each row to { ...row, selected } and attaches selectAll + totalCount.
 *
 * @deprecated Since the Table-owned toolbar (plan `table-owned-toolbar-selection`, 2026-09-09).
 * New listings pass `selection={{ mode: 'entire', selectAllLabel, resetKey }}` to `Table`
 * and let the molecule own selection. Retained for consumers still on the controlled
 * `selectedItems` / `onSelectionChange` path: the proposal-wizard deficiencies step,
 * IIMReview IssuesGrid, and SprinklerProjection.
 * @see frontend/ui/molecules/Table/hooks/useTableSelection.ts
 */
export function toMassActionsListingState({ rows, selectedIds, selectAllEntire, totalCount, extras = {} }) {
    const safeExtras = Object.fromEntries(Object.entries(extras).filter(([key]) => !RESERVED_MASS_ACTION_KEYS.has(key)));
    return Object.assign(Object.assign({}, safeExtras), { data: rows.map((r) => (Object.assign(Object.assign({}, r), { selected: selectedIds.includes(r.id) }))), selectAll: selectAllEntire, totalCount });
}
